<app-loader *ngIf="loaderService.loading$ | async"></app-loader>
<!-- Notification System -->
<app-notification></app-notification>
<!-- Fixed Header -->
<app-header class="fixed top-0 left-0 w-full z-50"></app-header>

<!-- Main page content -->
<div class="pt-16 max-md:pt-[120px] min-h-screen flex flex-col">
  <router-outlet></router-outlet>
</div>

<!-- Footer -->
<app-footer></app-footer>
